import { type FieldKeyError, namedFieldKeyError } from '../../store/field-key';
import type { Property } from '../../store/types';

export type PropertyErrors = {
  name?: FieldKeyError;
  enumValues?: 'empty';
  noChildren?: 'empty';
  children?: Record<string, PropertyErrors>;
};

const hasValidEnumValues = (values: string[] | undefined): boolean => {
  if (!values || values.length < 2) return false;
  return values.every(value => value.trim().length > 0);
};

const validateProperty = (property: Property, siblings: Property[]): PropertyErrors | null => {
  const errors: PropertyErrors = {};
  const nameError = namedFieldKeyError(property, siblings);
  if (nameError) errors.name = nameError;
  if ((property.type === 'enum' || property.type === 'array<enum>') && !hasValidEnumValues(property.enumValues))
    errors.enumValues = 'empty';
  if (property.type === 'object' || property.type === 'array<object>') {
    const children = property.children ?? [];
    if (children.length === 0) errors.noChildren = 'empty';
    const childErrors = validateChildren(children);
    if (Object.keys(childErrors).length > 0) errors.children = childErrors;
  }
  return Object.keys(errors).length > 0 ? errors : null;
};

export const validateChildren = (children: Property[]): Record<string, PropertyErrors> => {
  const map: Record<string, PropertyErrors> = {};
  for (const child of children) {
    const e = validateProperty(child, children);
    if (e) map[child.id] = e;
  }
  return map;
};
